import '../sass/leadership-team.scss';
